import React from "react";
import { Dialog } from "@material-ui/core";
import {
  StyledDialogTitle,
  StyledDialogContent,
  StyledDialogActions,
  CancelButton,
  ConfirmButton,
  StyledTypography,
} from "./ConfirmationModal.styles";

/**
 * Modal de Confirmação reutilizável
 * 
 * @param {boolean} open - Controla a visibilidade do modal
 * @param {function} onClose - Callback executado ao fechar o modal
 * @param {function} onConfirm - Callback executado ao confirmar a ação
 * @param {string} title - Título do modal
 * @param {string} message - Mensagem de conteúdo do modal
 * @param {string} cancelText - Texto do botão de cancelar (default: "CANCELAR")
 * @param {string} confirmText - Texto do botão de confirmar (default: "CONFIRMAR")
 * @param {string} maxWidth - Largura máxima do modal (default: "sm")
 * @param {boolean} fullWidth - Se o modal deve ocupar toda a largura (default: true)
 */
const ConfirmationModal = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  cancelText = "CANCELAR",
  confirmText = "CONFIRMAR",
  maxWidth = "sm",
  fullWidth = true,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
    >
      <StyledDialogTitle>{title}</StyledDialogTitle>
      <StyledDialogContent>
        <StyledTypography>
          {message}
        </StyledTypography>
      </StyledDialogContent>
      <StyledDialogActions>
        <CancelButton onClick={onClose}>
          {cancelText}
        </CancelButton>
        <ConfirmButton onClick={onConfirm} variant="contained">
          {confirmText}
        </ConfirmButton>
      </StyledDialogActions>
    </Dialog>
  );
};

export default ConfirmationModal;
